module.exports = __webpack_public_path__ + "static/media/Week 2 Monday.33514c98.png";